import _Object$defineProperty from "@babel/runtime-corejs2/core-js/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs2/core-js/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _Object$values from "@babel/runtime-corejs2/core-js/object/values";
import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import CommonChrome from '../CommonChrome';
import NavSearch from '../CommonChrome/components/NavSearch';
import Content from '../CommonChrome/components/Content';
import { Breadcrumbs } from './Breadcrumbs';
import { getLinks } from './links/links';
import Side from './Side';
import Top from './Top';
import Toggle from './Toggle';
import AccountMenu from './AccountMenu';
import { FeatureFlag } from './featureFlags';
import classNames from 'classnames';
import { BasicUserContextProvider } from '../CommonChrome/components/UserContext/BasicUserContextProvider';
import { UserContext } from '../CommonChrome/components/UserContext';
import { toGatewayPermissionContext } from './Protected';
import { DOMAINS } from '../../config/domains';
export { orgIdToHrefFor } from './AccountMenu';
export var Navigation = /*#__PURE__*/function (_React$Component) {
  _inherits(Navigation, _React$Component);

  var _super = _createSuper(Navigation);

  function Navigation() {
    _classCallCheck(this, Navigation);

    return _super.apply(this, arguments);
  }

  _createClass(Navigation, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          organizationId = _this$props.organizationId,
          environment = _this$props.environment,
          featureFlags = _this$props.featureFlags,
          domains = _this$props.domains,
          context = _this$props.context,
          _this$props$UserConte = _this$props.UserContextProvider,
          UserContextProvider = _this$props$UserConte === void 0 ? BasicUserContextProvider : _this$props$UserConte,
          props = _objectWithoutProperties(_this$props, ["className", "organizationId", "environment", "featureFlags", "domains", "context", "UserContextProvider"]);

      var defaultDomains = DOMAINS[environment] || DOMAINS['staging'];

      var finalDomains = _objectSpread(_objectSpread({}, defaultDomains), domains);

      return /*#__PURE__*/React.createElement(UserContextProvider, null, /*#__PURE__*/React.createElement(UserContext.Consumer, null, function (userContext) {
        var _userContext$currentO;

        var orgId = ((_userContext$currentO = userContext.currentOrganization) === null || _userContext$currentO === void 0 ? void 0 : _userContext$currentO.id) || organizationId;
        var permissionContext = userContext.permissionContext || context && toGatewayPermissionContext(context);
        return /*#__PURE__*/React.createElement(CommonChrome, _extends({
          links: orgId && permissionContext ? getLinks({
            organizationId: orgId,
            environment: environment,
            featureFlags: featureFlags,
            domains: finalDomains,
            context: permissionContext
          }) : undefined,
          className: classNames('combined-navigation', className)
        }, props, {
          // Pass React.Fragment to CommonChrome as UserContextProvider,
          // since we need to support UserContextProvider at both levels
          // but don't want to end up actually rendering two of them.
          UserContextProvider: React.Fragment
        }));
      }));
    }
  }]);

  return Navigation;
}(React.Component);

_defineProperty(Navigation, "Search", NavSearch);

_defineProperty(Navigation, "Content", Content);

_defineProperty(Navigation, "Breadcrumbs", Breadcrumbs);

_defineProperty(Navigation, "Side", Side);

_defineProperty(Navigation, "Top", Top);

_defineProperty(Navigation, "Toggle", Toggle);

_defineProperty(Navigation, "AccountMenu", AccountMenu);

_defineProperty(Navigation, "FeatureFlags", _Object$values(FeatureFlag));

export default Navigation;